import { toast } from 'react-toastify';

export async function showFilterSearchError(text: string) {
  if (document.documentElement.dataset.design === 'modern') {
    toast.error(text, { autoClose: 2000 });
    return;
  }

  const { message } = await import('antd');
  message.error(text, 2);
}
